// import React, { useState } from 'react'
import NavBar from '../NavBar'
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Container, Row ,Card} from 'react-bootstrap'
// import bgimage from '../DetailsProduct/imeages/bgimage.jpg'
import imege2  from '../DetailsProduct/imeages/lab1.jpg'
import imege1 from '../DetailsProduct/imeages/lab.jpg' 
import {FaDatabase,FaLaptopCode, FaUserDoctor,FaComputer} from 'react-icons/fa6'
import { FaMobileAlt } from "react-icons/fa";
import { TbDeviceDesktopAnalytics } from "react-icons/tb";
// import { MdMedicalInformation } from "react-icons/md";

import '../App.css'
import { useTheme } from '../ThemeContext';
import Footer from '../Footer';

// models images
import salary from './imeages/salary.png'
import target from './imeages/target.png'
import control from './imeages/access-control.png'
import scalable from './imeages/scalability.png'
import security from './imeages/password.png'
import client from './imeages/public-relation.png'

const Limis = () => {
  // const models = [
  //   { icon: salary, title: "Improve your Revenue ", desc: ["Maintain Unique Patient. Simple Registration & Custom built Kiosks"] },
  //   { 
  //     icon: revenue,
  //     title: "Revenue Cycle Management", 
  //     desc:[ "Complete Control on defining Mastersand policies.",
  //         "Flexible Billing Options to make life easierfor Front Desk",
  //          "Robust MIS for Data Based Decision."],
  //   },
  //   { icon: <FaUserDoctor size={40} />, 
  //   title: "Clinical Workflow", 
  //   desc: ["Task Based Workflow to reduce human intervention & errors",
  //          "Completely Automated to improve TAT",
  //          "Flexible Configurations for ClinicalOperations"
  //   ], },
  //   { icon: < MdMedicalInformation size={40}/>, title: "Specialty LIMS", desc:["Custom Built Module for Histopathology& Microbiology",
  //     "AI Enabled Medical Dictionary fordictating reports"
  //   ]},
  //   { icon:<FaSearch size={30} />, 
  //   title: "Integrated QC & Inventory", desc:["Define QC Schedule ",
  //     "Capture QC Sera Attributes",
  //     "Prepare QC Samples",
  //     "Calculate Lab Mean & SD",
  //     "Visualize LJ Graph on demand for anynumber of Parameters",
  //     "Implement Westgard Rules and sensitise entire Team"

  //   ] },
  //   { icon:  <FaProjectDiagram size={30} /> , title: "Seamless 3rd PartyCommunication", desc: ["Easy Integration with all lab devicemanufacturers",
  //     "SAP Integrations",
  //     "Custom Connect"
  //   ] }
  // ];

  const models = [
    { icon: salary, title: "Improve your Revenue ", desc: "Manage Multiple Rate Cards, Business Promotions, Invoicing, Vendor Payments, Discounts with complete control and with flexibility to meet business objective " },
    { 
      icon: target,
      title: "100% clinically Accurate Report", 
      desc:"Our in-built workflow-based system ensures the right task is performed at the right time and accurate results are produced everytime ",
    },
    { icon: control , 
    title: "Complete Control of Lab Operations", 
    desc: "Manage your lab operations right from Patient Registration to Results Dispatch and all the process in between with ease"
     },
    { icon:client, title: "Empower your Clients and serve your patients  ", desc:"Seamless control of Clients and management allows you to serve your end customers with accurate reports at the same time of providing business flexibility "
    },
    { icon:security, 
    title: "Data Security and Patient Privacy", desc:"We take Patient's Data and its security seriously and ensure the data is secure and privacy is protected "

     },
    { icon:scalable , title: "Scalable Architecture ", desc: "Expand your business and focus on growth. Our Flexible Architecture takes care of your future IT needs"
    }
  ];
  const modules = [
    {
      title: <FaMobileAlt size={40} style={{ opacity: 0.7 }} />,
      subTittle:"Mobile Apps",
      items: [
        "Custom Built Mobile Apps for Customers",
        "Publishing of API for Customers to build their own Mobile Apps",
        "Mobile Apps built for Android & iOS eco System",
        "Mobile Apps for Pathologists, monitoring your home collections",
      ],
    },
    //  style={{ filter: "brightness(1.2) contrast(0.8)" }}
    {  
      title: <TbDeviceDesktopAnalytics size={50} style={{ opacity: 0.7 }}/>,
            subTittle:"Analytics",

      items: [
        "Advanced Analytics giving in-depth insights into Revenue, Operational & Clinical aspects",
        "Flexibility to communicate to any other system to fetch data for supplementing information-ETL",
        "Data based Decision Making at each & every step",
        "Hosted in Microsoft Environment, Analytics platform built in Power BI",
      ],
    },
    {
      title: <FaUserDoctor size={50} strokeWidth={1}  style={{ opacity: 0.7 }} />,
                  subTittle:"OPD Module",

      items: [
        "Comprehensive Suite for Doctors from registration to managing patient case sheets and all the steps in between",
        " Tailor made templates depending on the speciality( for ex:- Dermatologists can have a separate template and general physicians can have their own template)",
        "Seamless Integration with LIS & Inventory"
      ],
    },
  ];
  
  const sections = [
    {
      title: <FaLaptopCode size={50} style={{ opacity: 0.7 }}/>,
                  subTittle:"Frontend",

      items: [
        "Web API, .Net Core MVC",
        "Improved Performance of Application,Scalable & Robust"
      ]
    },
    {
      title: <FaComputer size={50}style={{ opacity: 0.7 }}/>,
                  subTittle:"Server Side",

      items: [
        "SQL-Scalable and Elastic Infrastructure.In built Features for enhanced datasecurity ",
        " Depending on the customer preference,we provide flexibility to choose between SQL/MY SQL/Postgreg",
        "On a case to case basis we offer ORACLEDB assistance at additional cost"
      ]
    },
    {
      title: <FaDatabase size={50} style={{ opacity: 0.7 }}/>,
                  subTittle:"BackEnd",

      items: [
        "Comprehensive Suite for Doctors",
        "Tailor-made templates for specialities",
        "Seamless Integration with LIS & Inventory"
      ]
    }
  ];
//  const [change,setChange] = useState()
  const {theme} = useTheme()
  return (
       <div style={{
        backgroundColor: theme === "dark" ? "#1e1e1e" : "",
        minHeight: "100vh", marginTop:'40px'
      }}>
        <NavBar />
   {/* #E2E8F0 */}


    <Container fluid className="py-5"
     style={{
      // backgroundImage:`url(${bgimage})`,
      backgroundImage: theme === "light" ? "" : "none",
      backgroundColor: theme === "dark" ? "#1e1e1e" : "none",
      backgroundSize: 'cover', 
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    }}
    >
      <Container>
        <Row className="d-flex justify-content-center align-items-center">
          {/* Text Section */}
          <Col xs={12} md={8}  className="text-center text-md-start ">
            <h1 className="fw-bold  text-decoration-underline">
              Laboratory Information Management <br />
              <span>Systems</span>
            </h1>
            <h4 className="text-primary mt-3 fw-bold">BBT Labs </h4>
            <p  className='fs-4'>
            BBT Labs is certified by 3 rd party VAPT Agencies on <br />
            potential vulnerabilities & external threats. We take <br />
            our Patients Data Seriously and it is 100% Safe % Secure.
            </p>
          </Col>

          {/* Image Section */}
          <Col xs={12} md={4} className="text-center align-items-start">
            <img
              style={{marginTop:'20%',marginRight:'40%',width:"400px",height:"400px",objectFit:"cover" }}
              src={imege1} 
              alt="Scientist illustration"
              className="rounded-circle img-fluid mx-auto d-block"
              // style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain" }}
            />
          </Col>
        </Row>
      </Container>

      <Container className='py-5 'style={{marginTop:'3%'}}>
         <h4 className='text-center text-primary'>FEATURES DESIGNED TO SCALE YOUR BUSINESS </h4>
          <Row className='align-items-center '>
            {/* <Col md={4} xs={12} className='mt-5'>
              <img 
              src={imege2}
              alt=" image2"
              className="img-fluid"
              />
            </Col > */}
             <Col md={4} xs={12} className='mt-5'>
              <img 
              src={imege2}
              height={500}
              width={500}
              alt=" image2"
              className="img-fluid"
              />
            </Col >
            <Col md={8} xs={12} className='py-5'>
              <ul className=' list-unstyled '>
                <li className=''>➤ Scale up your operations without worrying about IT </li>
                <li className=''>➤ Future Proof Technology Stack </li>
                <li>➤ Exhaustive Masters and transactional controls to build Flexibility & Control into your business operations </li>
                <li>➤ Integrated Inventory to track reagents. Clearly calculate Cost per test, cost per reportable test(CPT/CPRT) </li>
                <li>
                ➤ With robust QC Module ensure your patient's report is accurate and on time, every time. 
                </li>
                <li>
                ➤ Improve Efficiency, Reduce Cost, Increase Revenue. Focus on your Patients
                </li>
              </ul>
            
            </Col>
             
          </Row>
       </Container>
    
        {/* <Container>
        <h4 className='text-center text-primary'>HIGH LEVEL MODELS </h4>
        <Row className="justify-content-center">
        {models.map((model, index) => (
          <Col md={5} sm={12} key={index} className="mb-4">
            <Card className="d-flex flex-row align-items-center shadow-sm p-3 "style={{borderTopLeftRadius:'50px',borderBottomLeftRadius:'50px',minHeight:'300px'}}>
              <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center" style={{ width: "50px", height: "50px", fontSize: "1.5rem" }}>
                {model.icon}
              </div>
              <div className="ms-3">
                <h5 className="mb-1">{model.title}</h5>
                <p className="mb-0 text-muted">{model.desc}</p>
                <ul className='list-unstyled'>
                  {model.desc.map((item,idx)=>(
                       <li key={idx}> ➤ {item}</li>
                  ))}
                
                </ul>
              </div>
            </Card>
          </Col>
        ))}
      </Row>

  </Container> */}
  <Container>
        {/* <h4 className='text-center text-primary'>HIGH LEVEL MODELS </h4> */}
        <Row className="justify-content-center">
        {models.map((model, index) => (
          <Col md={4} sm={12} key={index} className="">  
                         
                                    {/* borderTopLeftRadius:'50px',borderBottomLeftRadius:'50px', */}
            <Card className="d-flex align-items-center  p-3 mb-3 "style={{minHeight:'300px'}}>
              {/* <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center" style={{fontSize: "1.5rem" }}>
              
              </div> */}
               <div className='d-flex align-items-center justify-content-center mb-3'>
                                  <img src={model.icon} alt={model.title} height={80} width={80} />

                          </div>
              <div className="ms-3">
                <h5 className="mb-1">{model.title}</h5>
                {/* <p className="mb-0 text-muted">{model.desc}</p> */}
                <ul className='list-unstyled'>
                 
                       <li > {model.desc}</li>
                  
                
                </ul>
              </div>
            </Card>
          </Col>
        ))}
      </Row>

  </Container>

  <Container fluid className="py-3">
      <h2 className="text-primary text-center ">Add On Modules</h2>
      <Row className="justify-content-center">
        {modules.map((module, index) => (
          <Col md={4} sm={12} key={index} className="mb-4">
            <Card className="shadow-sm border-0 "  style={{minHeight:'380px'}}>
              <Card.Header className=" text-dark text-center fw-bold fs-5">
                {module.title }
                
              </Card.Header>
              {/* <p className='fw-bold fs-4 ms-4'>Mobile APPS</p> */}
              <h5 className='fw-bold mt-3 ms-4'>{module.subTittle}</h5>
              <Card.Body>
                <ul className="list-unstyled">
                  {module.items.map((item, idx) => (
                    <li key={idx} className=" lh-3" >➤ {item}</li>
                  ))}
                </ul>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>

     <Container fluid >
              <h2 className='text-primary text-pperase text-center mb-4'>TECHNOLOGY STACK </h2>
              
              <Row className="justify-content-center">
              {sections.map((section,index)=>(
                 <Col md={4} xs={12} key={index}  className='mb-2'  >
                    <Card className='shadow-sm border-0' style={{minHeight:'330px'}}>
                      <Card.Header className=' text-dark text-center fw-bold fs-5'>
                        {section.title}
                        
                      </Card.Header>
                         <h5 className='fw-bold mt-3 ms-4'>{section.subTittle}</h5>

                      <Card.Body>
                        <ul className='list-unstyled'>
                          {section.items.map((item,idx)=>(
                            <li key={idx} className='lh-3'>➤ {item}</li>
                          ))}
                        </ul>
                      </Card.Body>
                    </Card>

                 </Col>
              ))}

                

              </Row>

     </Container>
    </Container>
     
     <Footer />

    </div>
  )
}

export default Limis